<template>
  <div class="change-currency-rate-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">
                Currency rate (NIS, Shekels / USD, Dollars):
              </div>
            </div>
          </v-card-title>
            <v-layout row wrap >
              <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
                <v-form ref="change_currency_rate" data-vv-scope="change_currency_rate" lazy-validation>
                  <v-layout row wrap px-2>
                    <v-flex xs12>
                      <v-text-field
                        label="NIS, Shekels / USD, Dollars"
                        v-model="rate"
                        v-validate="'required'"
                        data-vv-name="change_currency_rate.rate"
                        :error-messages="errors.collect('change_currency_rate.rate')"
                        v-on:keyup.enter="changeRate()"
                        required
                        height="32"
                        solo
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" class="submit"
                  @click="changeRate()"
                  :loading="loading"
                  :disabled="loading"
                >Change rate</v-btn>
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ChangeCurrencyRateBlock',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading: false,
      rate: 0,
      dictionary: {
        en: {
          custom: {
            'change_currency_rate.rate': {
              required: 'Currency rate required',
              float: 'Currency rate should be float'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    this.getRate()
  },
  methods: {
    getRate () {
      this.loading = true
      this.$store.dispatch('GET_CURRENCY_RATE').then(res => {
        console.log(res.actual_currency_rate)
        this.rate = res.actual_currency_rate
        this.loading = false
      }, err => {
        this.loading = false
        console.log('GET_CURRENCY_RATE error', err)
        this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    changeRate () {
      this.$validator.validateAll('change_currency_rate').then(res => {
        if (res) {
          this.loading = true
          this.$store.dispatch('SET_CURRENCY_RATE', this.rate).then(res => {
            this.loading = false
            this.$toasted.show('Currency rate was successfully changed')
          }, err => {
            this.loading = false
            console.log('SET_CURRENCY_RATE error', err)
            this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    clearForm () {
      this.rate = null
      setTimeout(() => {
        this.$validator.errors.clear('change_currency_rate')
        this.$refs.change_currency_rate.resetValidation()
      }, 50)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/ChangeCurrencyRateBlock.vue